var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 39.1667C15.3333 34.4533 15.3333 32.095 16.7983 30.6317C18.2617 29.1667 20.62 29.1667 25.3333 29.1667H38.6667C43.38 29.1667 45.7383 29.1667 47.2017 30.6317C48.6667 32.095 48.6667 34.4533 48.6667 39.1667C48.6667 43.88 48.6667 46.2383 47.2017 47.7017C45.7383 49.1667 43.38 49.1667 38.6667 49.1667H25.3333C20.62 49.1667 18.2617 49.1667 16.7983 47.7017C15.3333 46.2383 15.3333 43.88 15.3333 39.1667Z",
    stroke: "#070600",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29.1667V25.8333C22 23.1812 23.0536 20.6376 24.9289 18.7623C26.8043 16.8869 29.3478 15.8333 32 15.8333C34.6522 15.8333 37.1957 16.8869 39.0711 18.7623C40.9464 20.6376 42 23.1812 42 25.8333V29.1667",
    stroke: "#070600",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 39.1667H25.3483M31.985 39.1667H32M38.6517 39.1667H38.6667",
    stroke: "#070600",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot_password.3a7fdac0d05f990c88eb9e044cb0465c.svg";
export { ForwardRef as ReactComponent };